import { AppUser } from '@eventr/common'

export const searchMembersFilter = (
    userFilter: AppUser,
    searchFilter: string
) => {
    if (searchFilter.length < 1) {
        return userFilter
    } else {
        const name = `${userFilter.firstName.toLowerCase()} 
        ${userFilter.lastName.toLowerCase()} 
        ${userFilter.email.toLowerCase()}
        ${(userFilter.departmentTags ?? [])
            .map((tag) => tag.toLowerCase())
            .join(' ')}
        ${(userFilter.groupTags ?? [])
            .map((tag) => tag.toLowerCase())
            .join(' ')}
        `

        if (name.includes(searchFilter)) {
            return userFilter
        } else {
            return undefined
        }
    }
}
